<template>
	<div class="login" @keydown.enter="keydownMethod">
		<div class="login-content">
			<div class="login-title">
				大德拍卖后台管理系统
			</div>
			<el-form ref="loginForm" :model="loginForm" label-width="80px" :rules="rules">
				<el-form-item label="账号" prop="account">
					<el-input v-model="loginForm.account" placeholder="请输入账号" clearable></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input type="password" v-model="loginForm.password" placeholder="请输入密码" clearable></el-input>
				</el-form-item>
				<div class="login-button">
					<el-button type="primary" :loading="loading" @click="doLogin()">立即登录</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex';
	export default {
		name: 'login',
		data() {
			let verify_account = (rule, value, callback) => {
				if (this.loginForm.account == '') {
					callback(new Error('请输入账号'))
				} else {
					callback()
				}
			}
			let verify_password = (rule, value, callback) => {
				if (!this.$ver.verify_password(this.loginForm.password)) {
					callback(new Error('请输入5-18位密码'))
				} else {
					callback()
				}
			}
			return {
				loginForm: {
					account: '',
					password: ''
				},
				rules: {
					account: [{
						required: true,
						trigger: 'blur',
						validator: verify_account
					}],
					password: [{
						required: true,
						trigger: 'blur',
						validator: verify_password
					}]
				},
				loading: false
			};
		},
		methods: {
			...mapMutations(['admLogin']),
			doLogin() {
				this.$refs.loginForm.validate(valid => {
					if (valid) {
						this.loading = true
						this.$api.admlogin({
							'username': this.loginForm.account,
							'password': this.loginForm.password
						}, res => {
							this.loading = false
							if (res.code == 200) {
								sessionStorage.setItem('account', this.loginForm.account)
								this.admLogin(res.data.token)
								this.$notify({
									title: '成功',
									message: '登录成功，即将为您跳转',
									type: 'success',
									duration: 1500,
									onClose: () => {
										this.$router.push({
											path: '/manage'
										})
									}
								})
							}
						})
					}
				})
			},
			keydownMethod() {
				this.doLogin()
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			localStorage.removeItem('adm_token')
			localStorage.removeItem('admNavigateIndex')
			this.$api.resetHeader()
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style lang="less" scoped="scoped">
	.login {
		width: 100vw;
		height: 100vh;
		min-width: 1600px;
		min-height: 860px;
		background: url(../../assets/manage-back.jpg);
		display: flex;
		justify-content: center;
		align-items: center;

		.login-content {
			width: 500px;
			background: @vue-bg-color;
			border-radius: @vue-border-radius-lg;
			box-shadow: 0px 0px 0px @vue-border-color;
			padding: @vue-spacing-row-lg @vue-spacing-col-lg;

			.login-title {
				width: 100%;
				height: 60px;
				display: flex;
				justify-content: center;
				font-size: @vue-font-size-base;
				font-weight: bold;
			}

			.login-button {
				width: 100%;
				display: flex;
				justify-content: center;
				margin-top: @vue-spacing-col-lg;

				.el-button {
					width: 150px;
				}
			}
		}
	}
</style>
